// Font family constants
const fonts = {
  heading: "Kaisei Decol, serif",
  body: "Kiwi Maru, serif",
};

const fontSizes = {
  small: "12px",
  medium: "16px",
  large: "24px",
};

// Color palette
const colors = {
  text: {
    primary: "#ad3d48",
    secondary: "#AAAAAA",
    warning: "red",
  },
  background: {
    card: "rgba(255, 255, 255, 0.5)",
    dialog: "#0B0A2E",
  },
};

const system = {
  fonts: fonts,
  fontSizes: fontSizes,
  colors: colors,
};
export default system;
